import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Skeleton,
  Row,
  Col,
  Divider,
  Form,
  message,
  notification,
  List,
  Upload,
  Input,
  Modal,
} from "antd";
import { connect } from "react-redux";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { Link, useLocation, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import _ from "lodash";
import { FilePreviewerThumbnail } from "react-file-previewer";

/* custom component */
import { ViewBox, ViewLabel, ViewValue } from "../../../component/Xcomponent";

/* action */
import {
  getAppointmentDetail,
  getAppointmentDetailReset,
} from "../../../action/getAppointmentDetailAction";
import {
  saveAppointmentReport,
  saveAppointmentReportReset,
} from "../../../action/saveAppointmentReportAction";

import {
  cancelAppointment,
  cancelAppointmentReset
} from "../../../action/cancelAppointmentAction";

import {
  convertTZ,
  dateFormat,
  dateTimeFormat,
  dateToString,
  getS3SingedUrl,
  lilac_doctor_site,
  s3_cdn,
  timeSlotFormat,
  validateImagePdfFile,
} from "../../../utils";
import { CustomTabPane, CustomTabs } from "./AppointmentViewStyle";
import moment from "moment";
const AppointmentView = (props) => {
  /* variable */
  const search = useLocation().search;
  const history = useHistory();
  const pid = new URLSearchParams(search).get("id");
  const {
    getDoctorDetailState,
    getAppointmentDetail,
    getAppointmentDetailReset,
    getAppointmentDetailState,
    saveAppointmentReport,
    saveAppointmentReportReset,
    saveAppointmentReportState,
    cancelAppointment,
    cancelAppointmentState,
    cancelAppointmentReset
  } = props;
  const [defaultActiveKey, setDefaultActiveKey] = useState("appointment");
  const [canJoin, setCanJoin] = useState(false);
  const [canCancelAppointment, setCanCancelAppointment] = useState(false);
  const [form] = Form.useForm();
  const inititalFormData = {
    file_path: [],
    patient_id: "",
    book_appointment_id: "",
    report_of: "doctor",
    title: "",
  };
  const [formData, setFormData] = useState(inititalFormData);
  const [fileList, setFileList] = useState([]);
  const [modal, contextHolder] = Modal.useModal();
  /* callbacks */
  useEffect(() => {
    console.log("jit", props.jit);
    if (props.visible === false) {
      getAppointmentDetailReset();
      saveAppointmentReportReset();
      setDefaultActiveKey("appointment");
    }
  }, [props.visible]);

  useEffect(() => {
    if (props.id && props.visible) {
      getAppointmentDetail({
        id: props.id,
      });
    }
    if (pid) {
      getAppointmentDetail({
        id: pid,
      });
    }
  }, [props.id, props.visible]);

  useEffect(() => {
    if (getAppointmentDetailState.apiState === "success") {
      // let date = moment(getAppointmentDetailState.data.date).utc().unix();
      // let to_date = moment(getAppointmentDetailState.data.to_date).utc().unix();
      // let current_date = convertTZ(
      //   moment().format("YYYY-MM-DD HH:mm:ss") + " +0000",
      //   "Asia/Kolkata"
      // );

      // current_date = moment(current_date).utc().unix();
      // console.log(date, current_date, to_date);
      // if (date <= current_date && to_date >= current_date) {
      //   setCanJoin(true);
      // }

      if(getAppointmentDetailState.data.is_can_join_room)
      {
        setCanJoin(true);
      }
      if(getAppointmentDetailState.data.is_can_cancel_appointment)
      {
        setCanCancelAppointment(true);
      }
      setFormData({
        ...formData,
        ["patient_id"]: getAppointmentDetailState.data.patient_id
          ? getAppointmentDetailState.data.patient_id._id
          : "",
        ["book_appointment_id"]: getAppointmentDetailState.data._id,
      });
    }
  }, [getAppointmentDetailState]);

  useEffect(() => {
    if (saveAppointmentReportState.apiState === "success") {
      getAppointmentDetail({
        id: props.id,
      });
      // getAppointmentDetail({
      //   id: pid,
      // });
      saveAppointmentReportReset();
      notification["success"]({
        message: saveAppointmentReportState.message,
        placement: "topRight",
      });
      setFormData({ ...formData, ["file_path"]: [] });
      setFileList([]);
      form.setFieldsValue({
        report: null,
      });
    }
    if (saveAppointmentReportState.apiState === "error") {
      saveAppointmentReportReset();
      notification["error"]({
        message: saveAppointmentReportState.message,
        placement: "topRight",
      });
    }
  }, [saveAppointmentReportState]); 

  useEffect(()=>{
    if(cancelAppointmentState.apiState=="success")
    {
      cancelAppointmentReset()
      window.location.reload();
      notification.success({
        message:"Appointment Cancelled Successfully",
      });
    }
    else if(cancelAppointmentState.apiState=="error")
    {
      cancelAppointmentReset()
      notification.error({
        message:cancelAppointmentState.message, 
      })
    }
  },[cancelAppointmentState]);

  // Functions
  const callback = (key) => {
    setDefaultActiveKey(key);
  };

  const onFinish = async (values) => {
    console.log(values);
    if (fileList) {
      let file_path_url = [];
      const promises = fileList.map(async (file) => {
        let filename = uuidv4();
        let imageValidationRes = validateImagePdfFile(file);
        if (imageValidationRes.status) {
          let s3UrlResImage = await getS3SingedUrl(
            filename,
            imageValidationRes.ext,
            file,
            "doctor-report"
          );
          await axios.put(s3UrlResImage.url, file);
          let data = {
            "title":values.report_title,
            "file_path":`${filename}.${imageValidationRes.ext}`,
          }
          file_path_url.push(data);
          // formData.file_path = `${filename}.${imageValidationRes.ext}`
        } else {
          alert("Select file type JPG, PNG or PDF file.");
          return;
        }
      });

      await Promise.all(promises);
      const reports ={
        "reports":file_path_url,
        "patient_id":formData.patient_id,
        "book_appointment_id":formData.book_appointment_id,
        "report_of":"doctor"
      }
      // formData.file_path = file_path_url;
      // formData.title = values.report_title;
      // setFormData({ ...formData, ['file_path']: file_path_url })
      saveAppointmentReport(reports);
    } else {
      return true;
    }
    // saveAppointmentReport(formData)
  };

  const confirmCancelAppointment = async (id, patient_name) => {
    let patientName = patient_name ? patient_name?.firstName+ " " + patient_name?.lastName : "this patient";
    modal.confirm({
      title: 'Are you sure?',
      content: 'Your appointment with '+patientName+' will be cancelled',
      okText: "Confirm",
      onOk(){
        return new Promise((resolve,reject)=>{
          cancelAppointment({book_appointment_id: id});
          if(["success", "error"].includes(cancelAppointmentState.apiState))
          {
            return resolve();
          }
          else {
            resolve()
            // return modal.cancel()
          }
        }) 
        
      },
      // confirmLoading: cancelAppointmentState.apiState==="loading",
    })
  };

  return (
    <>
    {
      getDoctorDetailState.apiState=="success"&&getDoctorDetailState.data.is_dcp_activated=="Yes" ? 
      <Drawer
        title={<p style={{fontSize: "large", marginBottom:"0"}}>
          Appointment View {
            getAppointmentDetailState.apiState === "success"
              ? "- " + getAppointmentDetailState.data.appointment_no
              : ""
          }
        </p>
      }
        placement="right"
        closeIcon={
          <>
            <Button className="d-flex justify-content-center align-items-center " size="small" shape="circle" icon={<CloseOutlined />} />
          </>
        }
        onClose={props.onClose}
        visible={props.visible}
        className="customWidthDrower"
      >
        {getAppointmentDetailState.apiState === "loading" && <Skeleton active />}

        {getAppointmentDetailState.apiState === "error" && (
          <p>{getAppointmentDetailState.message}</p>
        )}

        {getAppointmentDetailState.apiState === "success" && (
          <>
            <CustomTabs
              tabPosition="top"
              activeKey={defaultActiveKey}
              size="small"
              onChange={callback}
            >
              <CustomTabPane tab={`Appointment`} key={`appointment`}>
                <Row gutter={20}>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Appointment No.</ViewLabel>
                      <ViewValue>
                        <span>
                          {getAppointmentDetailState.data.appointment_no}
                        </span>
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Payment ID</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.payment_id}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Date</ViewLabel>
                      <ViewValue>
                        {dateToString(getAppointmentDetailState.data.date)}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Time Slot</ViewLabel>
                      <ViewValue>
                        {timeSlotFormat(
                          getAppointmentDetailState.data.time_slot_start
                        )}{" "}
                        -{" "}
                        {timeSlotFormat(
                          getAppointmentDetailState.data.time_slot_end
                        )}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Name</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.some_one_else
                          ? getAppointmentDetailState.data.full_name
                          : getAppointmentDetailState.data.patient_id
                          ? `${getAppointmentDetailState.data.patient_id?.name.firstName} ${getAppointmentDetailState.data.patient_id?.name.lastName}`
                          : ""}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Patient Photo</ViewLabel>
                      <ViewValue>
                        <img
                          src={
                            getAppointmentDetailState.data.patient_id?.profile_pic ? 
                            `${s3_cdn()}patient/${getAppointmentDetailState.data.patient_id?.profile_pic}`
                            :
                            getAppointmentDetailState.data.patient_id?.gender.toLowerCase() == "male" ?
                              `/images/svg/avatar_male.svg`
                            :
                            getAppointmentDetailState.data.patient_id?.gender.toLowerCase() == "female" ?
                              `/images/svg/avatar_female.svg`
                            :
                            `/images/svg/avatar_transgender.svg`
                          }
                          width="40"
                          height="40"
                          style={{borderRadius: "5px"}}
                        >
                        </img>
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Mobile No.</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.some_one_else
                          ? getAppointmentDetailState.data.phone
                          : getAppointmentDetailState.data.patient_id
                          ? getAppointmentDetailState.data.patient_id.phone
                          : ""}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  {/* <Col span="12">
                    <ViewBox>
                      <ViewLabel>Address</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.patient_id
                          ? getAppointmentDetailState.data.patient_id.address
                          : ""}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>City</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.patient_id
                          ? getAppointmentDetailState.data.patient_id.city
                          : ""}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Pincode</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.patient_id
                          ? getAppointmentDetailState.data.patient_id.pincode
                          : ""}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Service Type</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.service_type}
                      </ViewValue>
                    </ViewBox>
                  </Col>

                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Symptoms</ViewLabel>
                      <ViewValue>
                        {getAppointmentDetailState.data.symptoms}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>Status</ViewLabel>
                      <ViewValue style={{ textTransform: "capitalize" }}>
                        {getAppointmentDetailState.data.status}
                      </ViewValue>
                    </ViewBox>
                  </Col> */}
                  {/* <Col span="12">
                    <ViewBox>
                      <ViewLabel>CreatedAt</ViewLabel>
                      <ViewValue>
                        {dateFormat(getAppointmentDetailState.data.createdAt)}
                      </ViewValue>
                    </ViewBox>
                  </Col>
                  <Col span="12">
                    <ViewBox>
                      <ViewLabel>UpdatedAt</ViewLabel>
                      <ViewValue>
                        {dateFormat(getAppointmentDetailState.data.updatedAt)}
                      </ViewValue>
                    </ViewBox>
                  </Col> */}
                </Row>
                <br />
                {canJoin ? (
                  <Row gutter={20}>
                    <Col span="12">
                      <h5>Join a Meeting</h5>
                      <br />
                      <Link to={`/appointment/meeting/${props.id}`}>
                        <Button className="borderPrimary" type="primary">Let's Start</Button>
                      </Link>
                    </Col>
                  </Row>
                ) : (
                  <Row gutter={20}>
                    <Col span="12">
                      <h5>Join a Meeting</h5>
                      <br />
                      <Link >
                        <Button disabled>Let's Start</Button>
                      </Link>
                    </Col>
                  </Row>
                )}
                <br />
                {canCancelAppointment && 
                  <Row gutter={20}>
                    <Col span="12">
                      <Button className="borderPrimary" type="primary" onClick={()=>confirmCancelAppointment(getAppointmentDetailState.data._id,getAppointmentDetailState.data.patient_id.name)}>Cancel Appointment</Button>
                    </Col>
                  </Row>
                }
              </CustomTabPane>
              {/* <CustomTabPane tab={`Intake`} key={`intake`}>
                {getAppointmentDetailState.apiState === "success" && (
                  <>
                    <Link
                      to={{
                        pathname: `${lilac_doctor_site()}patient-intake-form/${
                          getAppointmentDetailState.data._id
                        }`,
                      }}
                      target="_blank"
                    >
                      {" "}
                      Click here to fill the patient intake form.
                    </Link>
                  </>
                )}
                {getAppointmentDetailState.apiState === "success" &&
                  getAppointmentDetailState.data.patient_intake && (
                    <>
                      {getAppointmentDetailState.data.patient_intake
                        .consultation_type === "GC" && (
                        <Row gutter={20}>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Full Name</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .name
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Age</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .age
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Gender</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .gender
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>
                                Referring clinician / Hospital name
                              </ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .referred_by
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Phone Number</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .phone
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>E-mail ID</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .email
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>State / City / District</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .city
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Referral reason</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .referral_reason
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>
                                Have you taken any previous consultation at Lilac?
                              </ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .previous_consultation_ddone_at_lilac
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>
                                Have you done any tests with Lilac Insights?
                              </ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .previous_tests_done
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>
                                Is this your first consultation with lilac?
                              </ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .first_followup
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                          <Col span="12">
                            <ViewBox>
                              <ViewLabel>Choose an appropriate option:</ViewLabel>
                              <ViewValue>
                                {
                                  getAppointmentDetailState.data.patient_intake
                                    .appropriate_option
                                }
                              </ViewValue>
                            </ViewBox>
                          </Col>
                        </Row>
                      )}
                      {getAppointmentDetailState.data.patient_intake
                        .consultation_type === "MHC" && (
                        <>
                          <h3>Personal Information</h3>
                          <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                          <Row gutter={20}>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Full Name</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .name
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Phone Number</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .phone
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Emergency Contact</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .emergency_contact
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Current Location (City)</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .city
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Referred by</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .referred_by
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Date of Birth</ViewLabel>
                                <ViewValue>
                                  {dateFormat(
                                    getAppointmentDetailState.data.patient_intake
                                      .dob
                                  )}
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Age</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .age
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Mention your sex</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .gender
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Your pronouns</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .pronouns
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Sexual orientation</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .sexual_orientation
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Marital Status</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .marital_status
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Are you currently employed?</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .employed
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>Are you a home maker?</ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .home_maker
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                          </Row>
                          <h3 style={{ marginTop: 20 }}>Client History</h3>
                          <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                          <Row gutter={20}>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Have you previously received any type of mental
                                  health services (psychotherapy, psychiatric
                                  services, etc.)?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .previously_taken_health_services
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Are you currently taking any psychiatric
                                  medication?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .psychiatric_medication
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Is there a history of mental illness in the
                                  family?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .mental_illness_in_family
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                          </Row>
                          <h3 style={{ marginTop: 20 }}>
                            Information on mental & physical health
                          </h3>
                          <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                          <Row gutter={20}>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  How would you rate your current physical health?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .current_physical_health
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  How would you rate your current sleeping habits?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .current_sleeping_habits
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  How would you rate your current eating habits?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .current_eating_habits
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Are you currently experiencing overwhelming
                                  sadness, grief or depression?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .experiencing_overwhelming_saddness_grief_or_depression
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  If yes, for approximately how long?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .how_long_experiencing_overwhelming_saddness_grief_or_depression
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Are you currently experiencing anxiety, panics
                                  attacks or have any phobias?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .experiencing_anxiet_panic_attacks
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  If yes, when did you begin experiencing this?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .experiencing_anxiet_panic_attacks_when_started
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  Do you drink alcohol more than once a week?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .drink_alcohol
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="12">
                              <ViewBox>
                                <ViewLabel>
                                  How often do you engage in recreational drug
                                  use?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .recreational_drug_use
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="24">
                              <ViewBox>
                                <ViewLabel>
                                  What significant life changes or stressful
                                  events have you experienced recently?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .significant_life_changes
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                            <Col span="24">
                              <ViewBox>
                                <ViewLabel>
                                  What are your expectations from therapy?
                                </ViewLabel>
                                <ViewValue>
                                  {
                                    getAppointmentDetailState.data.patient_intake
                                      .expectations_from_therapy
                                  }
                                </ViewValue>
                              </ViewBox>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  )}
              </CustomTabPane> */}
              <CustomTabPane tab={`Doctor Report`} key={`doctor-report`}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                  <Row gutter={20}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="report_title"
                        label="Report Title"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <Input
                          name="report_title"
                          placeholder="Report Title"
                        >
                        </Input>
                      </Form.Item>
                      <Form.Item
                        name="report"
                        label="Upload Report (Image/PDF)"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <Upload
                          name="report"
                          beforeUpload={(file) => {
                            if (
                              file.type === "image/png" ||
                              file.type === "image/jpg" ||
                              file.type === "image/jpeg" ||
                              file.type === "application/pdf"
                            ) {
                              let fileData = fileList;
                              fileData.push(file);
                              setFileList(fileData);
                            } else {
                              message.error(`Select png, jpg or pdf file only.`);
                            }
                            return file.type === "image/png" ||
                              file.type === "image/jpg" ||
                              file.type === "image/jpeg" ||
                              file.type === "application/pdf"
                              ? true
                              : Upload.LIST_IGNORE;
                          }}
                          onRemove={(file) => {
                            const index = fileList.indexOf(file);
                            const newFileList = fileList.slice();
                            newFileList.splice(index, 1);
                            setFileList(newFileList);
                          }}
                          fileList={fileList}
                          allowedFileTypes={["image/jpg", "image/jpeg"]}
                          fileTypeValidationMessage={
                            "Only JPG & JPEG file types allowed!"
                          }
                        >
                          <Button className="borderNonPrimary" icon={<UploadOutlined />}>Select File</Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button
                      className="borderPrimary"
                      type="primary"
                      htmlType="submit"
                      loading={saveAppointmentReportState.apiState === "loading"}
                    >
                      Submit
                    </Button>
                  </Form.Item>

                  <Divider></Divider>
                  <List
                    size="small"
                    bordered
                    dataSource={_.filter(getAppointmentDetailState.data.report, {
                      report_of: "doctor",
                    })}
                    renderItem={(item) => (
                      <List.Item
                      > 
                        <List.Item.Meta
                          
                          title={item.title ? item.title : "Report By Doctor"}
                          description={<>
                            <Link
                              to={{
                                pathname: `${s3_cdn()}doctor-report/${
                                  item.file_path
                                }`,
                              }}
                              target="_blank"
                              download
                            >
                              Download Report
                            </Link>
                            {/* <FilePreviewerThumbnail
                              style={{ width: 50, height: 50 }}
                              file={{
                                url: `${s3_cdn()}doctor-report/${item.file_path}`,
                              }}
                            /> */}
                          </>}
                        />
                      </List.Item>
                    )}
                  />
                </Form>
              </CustomTabPane>
              <CustomTabPane tab={`Patient Report`} key={`patient-report`}>
                <List
                  size="small"
                  bordered
                  dataSource={_.filter(getAppointmentDetailState.data.report, {
                    report_of: "patient",
                  })}
                  renderItem={(item) => (
                    <List.Item
                    >
                      <List.Item.Meta
                        title={item.title}
                        description={<>
                          <Link
                            to={{
                              pathname: `${s3_cdn()}patient-report/${item.file_path}`,
                            }}
                            target="_blank"
                            download
                          >
                            Download Report
                          </Link>
                          {/* <FilePreviewerThumbnail
                            style={{ width: 50, height: 50 }}
                            file={{
                              url: `${s3_cdn()}patient-report/${item.file_path}`,
                            }}
                          /> */}
                        </>}
                      />
                    </List.Item>
                  )}
                />
              </CustomTabPane>
            </CustomTabs>
            {contextHolder}
          </>
        )}
      </Drawer>
      :
      <Drawer>
        <h6>Access Not Authroized</h6>
      </Drawer>
    }
    </>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getAppointmentDetailState: state.getAppointmentDetail,
  saveAppointmentReportState: state.saveAppointmentReport,
  cancelAppointmentState: state.cancelAppointment,
});

const mapDispatchToProps = (dispatch) => ({
  getAppointmentDetail: (params) => dispatch(getAppointmentDetail(params)),
  getAppointmentDetailReset: () => dispatch(getAppointmentDetailReset()),
  saveAppointmentReport: (params) => dispatch(saveAppointmentReport(params)),
  saveAppointmentReportReset: () => dispatch(saveAppointmentReportReset()),
  cancelAppointment: (params) => dispatch(cancelAppointment(params)),
  cancelAppointmentReset: (params) => dispatch(cancelAppointmentReset(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentView);
